import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
} from '@angular/core';
import { Observable } from 'rxjs';
import { EntData } from '@bazis/shared/models/srv.types';
import { map } from 'rxjs/operators';
import * as L from 'leaflet';
import { fromGeoJson } from '@bazis/map/services/map-utils';
import { ConfigurationService } from '@app/configuration.service';

@Component({
    selector: 'app-list-map',
    templateUrl: 'list-map.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ListMapComponent implements OnInit {
    @Input()
    entities$: Observable<EntData[]>;

    @Input()
    geometryField = 'point';

    @Input()
    tile;

    @Input()
    defaultZoom = 4;

    @Input()
    layerSettings;

    @Input()
    processLayerFn;

    @Output()
    popupAction = new EventEmitter();

    layers$;

    mapSettings$;

    constructor(private configurationService: ConfigurationService) {}

    ngOnInit() {
        this.layers$ = this.entities$.pipe(
            map((entities) => {
                return {
                    listLayer: {
                        id: 'listLayer',
                        type: 'marker',
                        hasPopup: true,
                        zIndex: 500,
                        updatedTime: new Date().getTime(),
                        ...this.layerSettings,
                        objects: entities
                            .filter((entity) => entity[this.geometryField])
                            .map((entity) => this.processLayerFn(entity)),
                    },
                };
            }),
        );

        this.mapSettings$ = this.entities$.pipe(
            map((entities) => {
                const points: L.LatLngExpression[] = entities
                    .filter((entity) => entity[this.geometryField])
                    .map((entity) => fromGeoJson(entity[this.geometryField]) as L.LatLngExpression);

                return {
                    tile: this.tile,
                    defaultLocation:
                        points.length > 0
                            ? L.latLngBounds(points).getCenter()
                            : this.configurationService.defaultLocation,
                    defaultZoom: this.defaultZoom,
                };
            }),
        );
    }

    reemitPopupAction(e) {
        this.popupAction.emit(e);
    }
}
